var _rect, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgThumbDown = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_3139",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_3139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6H34V32L20 46L17.5 43.5C17.2667 43.2667 17.075 42.95 16.925 42.55C16.775 42.15 16.7 41.7667 16.7 41.4V40.7L18.9 32H6C4.93333 32 4 31.6 3.2 30.8C2.4 30 2 29.0667 2 28V24C2 23.7667 2.03333 23.5167 2.1 23.25C2.16667 22.9833 2.23333 22.7333 2.3 22.5L8.3 8.4C8.6 7.73333 9.1 7.16667 9.8 6.7C10.5 6.23333 11.2333 6 12 6ZM30 10H12L6 24V28H24L21.3 39L30 30.3V10ZM34 32V28H40V10H34V6H44V32H34Z",
    fill: "#C90000"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThumbDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/thumb_down.1aa387e5.svg";
export { ForwardRef as ReactComponent };